import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var generateStyle = function generateStyle(componentTheme, props) {
  var printMq = '@media print';
  return {
    newItemButton: _objectSpread({
      border: 'none',
      margin: componentTheme.newItemButtonMargin,
      padding: componentTheme.newItemButtonPadding,
      backgroundColor: componentTheme.newItemButtonBackgroundColor,
      borderRadius: componentTheme.newItemButtonBorderRadius,
      lineHeight: 0,
      fontSize: componentTheme.newItemButtonFontSize,
      fontWeight: componentTheme.newItemButtonFontWeight,
      textAlign: 'center',
      color: componentTheme.newItemButtonColor,
      boxShadow: componentTheme.newItemButtonBoxShadow,
      transform: 'rotate(0deg)',
      transition: componentTheme.newItemButtonTransition,
      zIndex: componentTheme.newItemButtonZIndex,
      ':focus': {
        outline: componentTheme.newItemButtonFocusOutline,
        outlineOffset: componentTheme.newItemButtonFocusOutlineOffset
      }
    }, props.isEditing && {
      backgroundColor: componentTheme.newItemButtonEditingBackgroundColor,
      transform: 'rotate(45deg)',
      transition: componentTheme.newItemButtonTransition
    }),
    newItemButtonHolder: _defineProperty({
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      zIndex: componentTheme.newItemButtonHolderZIndex,
      marginTop: '-1.5rem'
    }, printMq, {
      display: 'none'
    }),
    attachQuestionButtonHolder: _defineProperty({
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      zIndex: componentTheme.attachQuestionButtonHolderZIndex
    }, printMq, {
      display: 'none'
    })
  };
};
export default generateStyle;